import React from 'react';

import FilterWrapper from '../../../../components/Common/FilterWrapper';
import InputWrapper from '../../../../components/Common/InputWrapper';
import NowSelect from '../../../../components/Common/NowSelect';
import FromToDatePicker from '../../../../components/Common/FromToDatePicker';
import { trans } from '../../../../localization/index';
import { getDate, getPermissionRestaurant } from '../../../../utils/utils';
import NowCheckbox from '../../../../components/Common/NowCheckbox';
import { EnumMerchantPermission } from '../../../../constants/enum';

class ReportRestaurantFilter extends React.Component {
  restaurantOptions = [
    {
      value: 0,
      label: trans('mod_all_restaurant'),
    },
    ...getPermissionRestaurant(
      this.props.restaurants,
      EnumMerchantPermission.REPORT_ALL.id,
    ).map(res => ({
      value: res.restaurant_id,
      label: res.is_use_partner_app ? (
        <div className="choose-restaurant-modal-option">
          {res.name}
          <div className="choose-restaurant-modal-option-tag">
            {trans('merchant_transfer_simpleDialog_text_transferred')}
          </div>
        </div>
      ) : res.name,
    })),
  ];

  handleChangeRestaurant = (value) => {
    const { filters, handleChangeFilters, handleSearch } = this.props;
    const { restaurant } = filters;

    if (value === null || value.value !== restaurant.value) {
      handleChangeFilters('restaurant', value);

      if (value && value.value !== 0) {
        handleChangeFilters('isShowTotal', false);
      }

      handleSearch();
    }
  };

  handleSearchToday = () => {
    const { handleChangeFilters, handleSearch } = this.props;
    handleChangeFilters('fromDate', getDate());
    handleChangeFilters('toDate', getDate());
    handleSearch();
  };

  handleChangeShowAllFilters = (value) => {
    const { handleChangeFilters, handleSearch } = this.props;
    handleChangeFilters('isShowTotal', value);
    if (value) {
      handleChangeFilters('restaurant', this.restaurantOptions[0]);
      handleSearch();
    }
  };

  render() {
    const {
      filters,
      handleSearch,
      handleChangeFilters,
      exportRestaurantReport,
    } = this.props;
    const {
      restaurant, fromDate, toDate, isShowTotal,
    } = filters;
    return (
      <FilterWrapper>
        <InputWrapper label={trans('mod_restaurant_list')} width={300}>
          <NowSelect
            value={restaurant}
            options={this.restaurantOptions}
            onChange={this.handleChangeRestaurant}
          />
        </InputWrapper>
        <InputWrapper label={trans('mod_filter_time')} width={300}>
          <FromToDatePicker
            fromDate={fromDate}
            toDate={toDate}
            handleChangeFromDate={date => handleChangeFilters('fromDate', date)}
            handleChangeToDate={date => handleChangeFilters('toDate', date)}
          />
        </InputWrapper>
        <InputWrapper>
          <button
            type="button"
            className="btn btn-red mr-2"
            onClick={handleSearch}
          >
            {trans('mod_filter_search')}
          </button>
          <button
            type="button"
            className="btn btn-white mr-2"
            onClick={this.handleSearchToday}
          >
            {trans('mod_filter_today')}
          </button>
          <button
            type="button"
            className="btn btn-white border"
            onClick={exportRestaurantReport}
          >
            {trans('mod_filter_export')}
          </button>
        </InputWrapper>
        <InputWrapper width={200}>
          <NowCheckbox
            id="isShowTotal"
            value={isShowTotal}
            name={trans('mod_show_total_order')}
            onChange={evt =>
              this.handleChangeShowAllFilters(evt.target.checked)
            }
          />
        </InputWrapper>
      </FilterWrapper>
    );
  }
}

export default ReportRestaurantFilter;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportRestaurant/components/ReportRestaurantFilter.jsx